/*
 * @Author: chengyu
 * @Date: 2022-09-23 12:04:27
 * @Description: LBS服务相关枚举
 */
/**
 * 地图服务端错误码
 */
export var LbsCodeEnum;
(function (LbsCodeEnum) {
    LbsCodeEnum[LbsCodeEnum["SUCCESS"] = 0] = "SUCCESS";
    LbsCodeEnum[LbsCodeEnum["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    LbsCodeEnum[LbsCodeEnum["ERROR"] = 101] = "ERROR";
    LbsCodeEnum[LbsCodeEnum["LACK_PARAMS"] = 102] = "LACK_PARAMS";
    LbsCodeEnum[LbsCodeEnum["INVALID_TOKEN"] = 103] = "INVALID_TOKEN";
    LbsCodeEnum[LbsCodeEnum["INVALID_PARAMS"] = 104] = "INVALID_PARAMS";
})(LbsCodeEnum || (LbsCodeEnum = {}));
/**
 * LBS地图服务，实现方式
 * - `HELLO` 哈罗实现
 * - `GAODE` 高德实现
 * - `GAODE_FRONT_END` 高德实现，在前端做数据转换，返回LBS格式的数据
 * - `NONE`  无
 */
export var ImplEnum;
(function (ImplEnum) {
    ImplEnum["HELLO"] = "HELLO";
    ImplEnum["GAODE"] = "GAODE";
    ImplEnum["GAODE_FRONT_END"] = "GAODE_FRONT_END";
    ImplEnum["NONE"] = "NONE";
})(ImplEnum || (ImplEnum = {}));
/**
 * 自研服务 逆地理编码接口，两种实现方式
 * 0 哈啰地图字段名（驼峰型）
 * 1 与高德命名完全一样的字段名
 */
export var AmapStandardEnum;
(function (AmapStandardEnum) {
    AmapStandardEnum[AmapStandardEnum["HELLO"] = 0] = "HELLO";
    AmapStandardEnum[AmapStandardEnum["GAODE"] = 1] = "GAODE";
})(AmapStandardEnum || (AmapStandardEnum = {}));
/**
 * LBS 错误码
 * https://hellobike.yuque.com/rtyizx/ggpmnl/ozfzlt
 */
export var LBSRequestErrorType;
(function (LBSRequestErrorType) {
    LBSRequestErrorType[LBSRequestErrorType["OK"] = 10000] = "OK";
    /**
     * 超限报错
     */
    LBSRequestErrorType[LBSRequestErrorType["CKQPS_HAS_EXCEEDED_THE_LIMIT"] = 10020] = "CKQPS_HAS_EXCEEDED_THE_LIMIT";
})(LBSRequestErrorType || (LBSRequestErrorType = {}));
/**
 * poi搜索 选择使用的场景
 */
export var PoiSearchUseTypeEnum;
(function (PoiSearchUseTypeEnum) {
    /**
     * 关键字搜索
     */
    PoiSearchUseTypeEnum["SEARCH_BY_KEYWORDS"] = "SEARCH_BY_KEYWORDS";
    /**
     * 周边搜索
     */
    PoiSearchUseTypeEnum["SEARCH_BY_PERIPHERY"] = "SEARCH_BY_PERIPHERY";
    /**
     * 多边形搜索
     */
    PoiSearchUseTypeEnum["SEARCH_BY_PLOYGON"] = "SEARCH_BY_PLOYGON";
    /**
     * id搜索
     */
    PoiSearchUseTypeEnum["SEARCH_BY_ID"] = "SEARCH_BY_ID";
    /**
     * adcode 查询(酒旅专供只支持自研究)
     */
    PoiSearchUseTypeEnum["SEARCH_BY_COUNTY_ADCODE"] = "SEARCH_BY_COUNTY_ADCODE";
    /**
     * geofenceId 查询(先通过 geofenceId 获取 polygon)
     */
    PoiSearchUseTypeEnum["SEARCH_BY_GEOFENCE_ID"] = "SEARCH_BY_GEOFENCE_ID";
})(PoiSearchUseTypeEnum || (PoiSearchUseTypeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGJzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvcmUvZW51bXMvbGJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7O0dBSUc7QUFFSDs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLFdBT1g7QUFQRCxXQUFZLFdBQVc7SUFDckIsbURBQU8sQ0FBQTtJQUNQLCtEQUFpQixDQUFBO0lBQ2pCLGlEQUFXLENBQUE7SUFDWCw2REFBVyxDQUFBO0lBQ1gsaUVBQWEsQ0FBQTtJQUNiLG1FQUFjLENBQUE7QUFDaEIsQ0FBQyxFQVBXLFdBQVcsS0FBWCxXQUFXLFFBT3RCO0FBRUQ7Ozs7OztHQU1HO0FBQ0gsTUFBTSxDQUFOLElBQVksUUFLWDtBQUxELFdBQVksUUFBUTtJQUNsQiwyQkFBZSxDQUFBO0lBQ2YsMkJBQWUsQ0FBQTtJQUNmLCtDQUFtQyxDQUFBO0lBQ25DLHlCQUFhLENBQUE7QUFDZixDQUFDLEVBTFcsUUFBUSxLQUFSLFFBQVEsUUFLbkI7QUFFRDs7OztHQUlHO0FBQ0gsTUFBTSxDQUFOLElBQVksZ0JBR1g7QUFIRCxXQUFZLGdCQUFnQjtJQUMxQix5REFBUyxDQUFBO0lBQ1QseURBQVMsQ0FBQTtBQUNYLENBQUMsRUFIVyxnQkFBZ0IsS0FBaEIsZ0JBQWdCLFFBRzNCO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxDQUFOLElBQVksbUJBTVg7QUFORCxXQUFZLG1CQUFtQjtJQUM3Qiw2REFBVSxDQUFBO0lBQ1Y7O09BRUc7SUFDSCxpSEFBb0MsQ0FBQTtBQUN0QyxDQUFDLEVBTlcsbUJBQW1CLEtBQW5CLG1CQUFtQixRQU05QjtBQUVEOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksb0JBeUJYO0FBekJELFdBQVksb0JBQW9CO0lBQzlCOztPQUVHO0lBQ0gsaUVBQXlDLENBQUE7SUFDekM7O09BRUc7SUFDSCxtRUFBMkMsQ0FBQTtJQUMzQzs7T0FFRztJQUNILCtEQUF1QyxDQUFBO0lBQ3ZDOztPQUVHO0lBQ0gscURBQTZCLENBQUE7SUFDN0I7O09BRUc7SUFDSCwyRUFBbUQsQ0FBQTtJQUNuRDs7T0FFRztJQUNILHVFQUErQyxDQUFBO0FBQ2pELENBQUMsRUF6Qlcsb0JBQW9CLEtBQXBCLG9CQUFvQixRQXlCL0IifQ==